import { z } from 'zod';
import { usernameSchema } from './enums.js';
// Auth contract (SPEC §3.1). Two fixed accounts; username is joel | lea.
export const loginRequestSchema = z.object({
    username: usernameSchema,
    password: z.string().min(1, 'Password is required'),
});
/** The current user as returned by POST /api/login and GET /api/me. */
export const sessionUserSchema = z.object({
    id: z.string(),
    username: usernameSchema,
    displayName: z.string(),
});
//# sourceMappingURL=auth.js.map